import { useEffect, useState } from "react";

let counter = 0;

/** One load per font file for the whole page: the card, the field and every
 *  picker tile showing the same font share one registered face, instead of
 *  each adding (and never removing) its own copy of a file up to 5 MiB. A
 *  failed load is forgotten, so a later specimen can try again. */
const loaded = new Map<string, Promise<string>>();

function loadFamily(url: string): Promise<string> {
    const cached = loaded.get(url);
    if (cached) return cached;
    counter += 1;
    const name = `ewt-specimen-${counter}`;
    const family = new FontFace(name, `url(${JSON.stringify(url)})`).load().then((face) => {
        document.fonts.add(face);
        return name;
    });
    family.catch(() => loaded.delete(url));
    loaded.set(url, family);
    return family;
}

/**
 * "Aa" drawn in a font file loaded straight from its URL — how a font shows up
 * wherever an image would show a thumbnail. If the file will not load, the
 * specimen stays in the UI font rather than going blank.
 */
export function FontSpecimen({ url, label, className }: { url: string | null; label: string; className?: string }) {
    const [family, setFamily] = useState<string | null>(null);

    useEffect(() => {
        setFamily(null);
        if (!url || typeof FontFace === "undefined") return;
        let alive = true;
        loadFamily(url)
            .then((name) => {
                if (alive) setFamily(name);
            })
            .catch(() => undefined);
        return () => {
            alive = false;
        };
    }, [url]);

    return (
        <span
            role="img"
            aria-label={`${label} specimen`}
            className={className}
            style={family ? { fontFamily: `"${family}"` } : undefined}
        >
            Aa
        </span>
    );
}
